import { upperFirst } from 'lodash'

import { components, proxy, services } from '@/utils'

import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'
import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'array' }) ],

    computed: {
      items() {
        const result = this.getSendingTypesByPermission(`advanced.${services.users}.update`)

        return result.map(value => {
          return {
            title: this.getTranslate(`${services.sendings}.types.${value}`),
            value,
            iconSVG: value,
            iconColor: value
          }
        })
      }
    },

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options, { type: 'array' }),
        {
          props: {
            value: this.proxy,
            items: [
              {
                component: components.select,
                props: {
                  items: this.items,
                  multiple: true
                },
                scopedSlots: {
                  selection: ({ item, removeByValue }) => {
                    return h(
                      RowWithMessageTypeIcon,
                      {
                        props: {
                          title: item.title,
                          value: item.value,
                          as: 'tag',
                          dense: true,
                          cancelable: true,
                          cancel: () => {
                            return removeByValue(item)
                          }
                        }
                      }
                    )
                  }
                }
              }
            ]
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
